module.exports = __webpack_public_path__ + "img/six3.317fbf6c.jpg";